// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"AppFeature_cardContainer__0o88Z","card":"AppFeature_card__QYvjD","imageContainer":"AppFeature_imageContainer__g5RVq"};